/** Figma `5106:10346` — Editor/Viewer dashboard layout tokens. */

import {
  SENSEMAKER_TABLE,
  sensemakerTableBodyCellSx,
  sensemakerTableHeaderCellSx,
} from '@/shared/table/sensemaker-table-theme'

export const EDITOR_VIEWER_DASHBOARD_LAYOUT = {
  metricGridGap: 3,
  metricsToSectionGap: '36px',
  /** Space below the welcome strip before Dashboard heading (Figma `4154:4576`). */
  welcomeBannerMarginBottom: '40px',
  sectionHeaderGap: '24px',
  sectionTitleColor: '#0f172a',
  sectionTitleLetterSpacing: '-0.44px',
  filterWidth: 225,
  paginationMinHeight: 52,
  paginationSelectBg: '#f1f5f9',
} as const

/** Figma `5106:10496` — Responses column progress bar. */
export const ALLOCATED_INSTRUMENTS_RESPONSE_PROGRESS = {
  trackBg: '#e2e8f0',
  barHeight: 9,
  barRadius: '12px',
  fill: {
    active: '#7C3AED',
    completed: '#DE6534',
    paused: '#94A3B8',
  },
  labelColor: '#4a5565',
  completedLabelColor: '#94a3b8',
  completedBarShadow: '0px 0px 10px 0px rgba(0, 96, 100, 0.3)',
  completedBarInsetShadow: 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
} as const

export const ALLOCATED_INSTRUMENTS_TABLE = {
  ...SENSEMAKER_TABLE,
  nameColor: SENSEMAKER_TABLE.primaryTextColor,
  campaignSubtitleColor: '#64748b',
  colNameWidth: '38%',
  colStatusWidth: '14%',
  colResponsesWidth: '28%',
  colActionsWidth: '20%',
  colActionsMinWidth: 120,
} as const

export const allocatedInstrumentsHeaderCellSx = sensemakerTableHeaderCellSx

export const allocatedInstrumentsBodyCellSx = sensemakerTableBodyCellSx
